import { UserTokenPayload } from '../types';
import { USER_ROLE } from './constants';

export const cln = (...classnames: (string | boolean | undefined)[]) =>
  classnames.filter(Boolean).join(' ');

export const urlWithParams = (path: string, params: Record<string, string>) => {
  return Object.entries(params).reduce(
    (prev, [k, v]) => prev.replaceAll(new RegExp(`:${k}`, 'g'), v),
    path,
  );
};

export const avatarUrl = (seed: string) =>
  `https://api.dicebear.com/5.x/initials/svg?seed=${seed.replaceAll(' ', '-')}`;

export const isClient = (user: UserTokenPayload) => user.role === USER_ROLE.CLIENT;
export const isSuperadmin = (user: UserTokenPayload) => user.role === USER_ROLE.SUPERADMIN;
